import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { Company } from '../../models/business/Company'
import { COMPANIES_URL } from '../../utils/urls'

const fetchCompanies = (params: TableParams) =>
  SBAPI.FetchPaginated<Company[]>(COMPANIES_URL, params)

const fetchCompanyById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<Company>(`${COMPANIES_URL}/${id}`, params)

const createCompany = (company: Company) => SBAPI.Post(COMPANIES_URL, company)

const updateCompany = (company: Partial<Company>) =>
  SBAPI.Put(`${COMPANIES_URL}/${company.id}`, company)

const deleteCompany = (company: Company) =>
  SBAPI.Delete(`${COMPANIES_URL}/${company.id}`)

const fetchRollingDays = (id: number, params?: TableParams) =>
  SBAPI.Fetch<number>(`${COMPANIES_URL}/${id}/rolling-days`, params)

export {
  createCompany,
  deleteCompany,
  fetchCompanies,
  fetchCompanyById,
  fetchRollingDays,
  updateCompany,
}
